"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.botTestOpenApiDocs = void 0;
exports.botTestOpenApiDocs = {
    'bot-test.list': {
        summary: 'List all bot tests',
        description: 'Get a paginated list of bot tests',
        parameters: [
            {
                name: 'q',
                in: 'path',
                required: false,
                schema: { type: 'string' },
                description: 'Search query'
            },
            {
                name: 'p',
                in: 'query',
                required: false,
                schema: { type: 'integer' },
                description: 'Page number'
            },
            {
                name: 'per_page',
                in: 'query',
                required: false,
                schema: { type: 'integer' },
                description: 'Items per page'
            }
        ],
        responses: {
            200: {
                description: 'List of bot tests',
                content: {
                    'application/json': {
                        schema: {
                            type: 'object',
                            properties: {
                                success: { type: 'boolean' },
                                data: {
                                    type: 'array',
                                    items: { $ref: '#/components/schemas/BotTest' }
                                },
                                count: { type: 'integer' }
                            }
                        }
                    }
                }
            }
        }
    },
    'bot-test.get': {
        summary: 'Get bot test by ID',
        description: 'Get a single bot test by its ID',
        parameters: [
            {
                name: 'id',
                in: 'path',
                required: true,
                schema: { type: 'string' },
                description: 'Bot test ID'
            }
        ],
        responses: {
            200: {
                description: 'Bot test details',
                content: {
                    'application/json': {
                        schema: {
                            type: 'object',
                            properties: {
                                success: { type: 'boolean' },
                                data: { $ref: '#/components/schemas/BotTest' }
                            }
                        }
                    }
                }
            },
            404: {
                description: 'Bot test not found'
            }
        }
    },
    'bot-test.run': {
        summary: 'Run bot test by ID',
        description: 'Run a single bot test by its ID',
        parameters: [
            {
                name: 'id',
                in: 'path',
                required: true,
                schema: { type: 'string' },
                description: 'Bot test ID'
            }
        ],
        responses: {
            200: {
                description: 'Bot test run successfully',
                content: {
                    'application/json': {
                        schema: {
                            type: 'object',
                            properties: {
                                success: { type: 'boolean' }
                            }
                        }
                    }
                }
            },
            404: {
                description: 'Bot test not found'
            }
        }
    },
    'bot-test.create': {
        summary: 'Create new bot test',
        description: 'Create a new bot test',
        requestBody: {
            required: true,
            content: {
                'application/json': {
                    schema: { $ref: '#/components/schemas/BotTestPayload' }
                }
            }
        },
        responses: {
            200: {
                description: 'Bot test created successfully',
                content: {
                    'application/json': {
                        schema: {
                            type: 'object',
                            properties: {
                                success: { type: 'boolean' },
                                data: { $ref: '#/components/schemas/BotTest' }
                            }
                        }
                    }
                }
            }
        }
    },
    'bot-test.update': {
        summary: 'Update bot test',
        description: 'Update an existing bot test',
        parameters: [
            {
                name: 'id',
                in: 'path',
                required: true,
                schema: { type: 'string' },
                description: 'Bot test ID'
            }
        ],
        requestBody: {
            required: true,
            content: {
                'application/json': {
                    schema: { $ref: '#/components/schemas/BotTestPayload' }
                }
            }
        },
        responses: {
            200: {
                description: 'Bot test updated successfully',
                content: {
                    'application/json': {
                        schema: {
                            type: 'object',
                            properties: {
                                success: { type: 'boolean' },
                                data: { $ref: '#/components/schemas/BotTest' }
                            }
                        }
                    }
                }
            }
        }
    },
    'bot-test.delete': {
        summary: 'Delete bot test',
        description: 'Delete a bot test by ID',
        parameters: [
            {
                name: 'id',
                in: 'path',
                required: true,
                schema: { type: 'string' },
                description: 'Bot test ID'
            }
        ],
        responses: {
            200: {
                description: 'Bot test deleted successfully',
                content: {
                    'application/json': {
                        schema: {
                            type: 'object',
                            properties: {
                                success: { type: 'boolean' },
                                data: { $ref: '#/components/schemas/BotTest' }
                            }
                        }
                    }
                }
            }
        }
    }
};
